import http from './http'

export function fetchNoticeList(site = 'zdr') {
  return http.get('/api/notice/list', { params: { site } })
}
